import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, SlidersHorizontal, Star, MapPin } from "lucide-react";


const centres = [
    { city: "Visakhapatnam", rating: 4.8, machines: 42, experts: 18, utilised: 78 },
    { city: "Vijayawada", rating: 4.7, machines: 36, experts: 14, utilised: 71 },
    { city: "Tirupati", rating: 4.6, machines: 29, experts: 12, utilised: 65 },
    { city: "Kurnool", rating: 4.5, machines: 24, experts: 9, utilised: 58 },
];

export default function Facilities() {
    const [view, setView] = useState("list");
    const [query, setQuery] = useState("");

    const filtered = centres.filter((c) =>
        c.city.toLowerCase().includes(query.toLowerCase())
    );

    return (
        <div>

            {/* Header band */}
            <section className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl">
                <div className="max-w-7xl mx-auto px-6 pt-14 pb-24">
                    <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-5">
                        Innovation Centres
                    </span>
                    <h1 className="text-4xl md:text-5xl font-extrabold mb-3">
                        Explore APIC Facilities
                    </h1>
                    <p className="text-indigo-100">
                        Discover state-of-the-art prototyping infrastructure across Andhra Pradesh.
                    </p>
                </div>
            </section>

            {/* Search bar - overlaps header/body */}
            <div className="max-w-7xl mx-auto px-6 -mt-12">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-3 flex flex-wrap items-center gap-3">
                    <div style={{ border: "1px solid #f0f0f0", borderRadius: "8px" }} className="flex items-center flex-1 min-w-[220px] gap-2 px-3">
                        <Search className="w-4 h-4 text-gray-400" />
                        <input
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search centre, city or technology..."
                            className="w-full py-2.5 text-sm focus:outline-none"
                        />
                    </div>

                    <button
                        type="button"
                        className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-medium hover:bg-gray-50"
                    >
                        <SlidersHorizontal className="w-4 h-4" />
                        Filters
                    </button>

                    <div className="flex bg-gray-100 rounded-xl p-1">
                        <button
                            type="button"
                            onClick={() => setView("list")}
                            className={`px-4 py-2 text-sm font-semibold rounded-lg transition ${view === "list" ? "bg-indigo-600 text-white" : "text-gray-600"
                                }`}
                        >
                            List
                        </button>
                        <button
                            type="button"
                            onClick={() => setView("map")}
                            className={`px-4 py-2 text-sm font-semibold rounded-lg transition ${view === "map" ? "bg-indigo-600 text-white" : "text-gray-600"
                                }`}
                        >
                            Map
                        </button>
                    </div>
                </div>
            </div>

            {/* Content */}
            <main className="max-w-7xl mx-auto px-6 py-12">
                {view === "list" ? (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {filtered.map(({ city, rating, machines, experts, utilised }) => (
                            <div
                                key={city}
                                className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm"
                            >
                                <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
                                    <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                                        <Star className="w-3 h-3 fill-white" /> {rating}
                                    </span>
                                    <div className="text-white">
                                        <p className="font-bold text-lg leading-tight">APIC {city}</p>
                                        <p className="flex items-center gap-1 text-sm text-indigo-100">
                                            <MapPin className="w-3.5 h-3.5" /> {city}
                                        </p>
                                    </div>
                                </div>

                                <div className="p-5">
                                    <div className="grid grid-cols-2 text-center mb-5">
                                        <div>
                                            <p className="font-bold text-gray-900">{machines}</p>
                                            <p className="text-[11px] text-gray-500 tracking-wide">MACHINES</p>
                                        </div>
                                        {/* <div>
                                            <p className="font-bold text-gray-900">{experts}</p>
                                            <p className="text-[11px] text-gray-500 tracking-wide">EXPERTS</p>
                                        </div> */}
                                        <div>
                                            <p className="font-bold text-gray-900">{utilised}%</p>
                                            <p className="text-[11px] text-gray-500 tracking-wide">UTILISED</p>
                                        </div>
                                    </div>

                                    <div className="flex gap-3">
                                        {/* <Link
                                            to={`/app/facilities/${city.toLowerCase()}/machines`}
                                            className="flex-1 text-center bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition"
                                        >
                                            Book a Machine
                                        </Link> */}
                                        <Link
                                            to={`/app/facilities/${city.toLowerCase()}/machines`}
                                            className="flex-1 text-center border border-gray-200 text-sm font-semibold py-2.5 rounded-xl hover:bg-gray-50 transition"
                                        >
                                            Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="h-96 rounded-2xl border border-dashed border-gray-300 flex items-center justify-center text-gray-400">
                        Map view coming soon
                    </div>
                )}
            </main>


        </div>
    );
}




// // import { useState } from "react";
// // import { Link } from "react-router-dom";
// // import { Search, Star, MapPin, Settings, ArrowRight } from "lucide-react";
// // import centres from "../data/centersData";

// // export default function Facilities() {
// //   const [query, setQuery] = useState("");

// //   const filtered = centres.filter((c) =>
// //     c.city.toLowerCase().includes(query.toLowerCase())
// //   );

// //   return (
// //     <div>
// //       <h1 className="text-3xl font-extrabold text-gray-900">APIC Facilities</h1>
// //       <p className="text-gray-500 mt-1 mb-6">
// //         Explore centres across Andhra Pradesh and book machines from within each centre.
// //       </p>

// //       {/* Search */}
// //       <div className="bg-white border border-gray-200 rounded-2xl p-3 mb-6">
// //         <div className="flex items-center gap-2 px-3">
// //           <Search className="w-4 h-4 text-gray-400" />
// //           <input
// //             value={query}
// //             onChange={(e) => setQuery(e.target.value)}
// //             placeholder="Search centre or city..."
// //             className="w-full py-2.5 text-sm focus:outline-none bg-transparent"
// //           />
// //         </div>
// //       </div>

// //       {/* Centre cards */}
// //       <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
// //         {filtered.map(({ city, rating, machines, experts, utilised }) => (
// //           <div
// //             key={city}
// //             className="rounded-2xl overflow-hidden border border-gray-100"
// //           >
// //             <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
// //               <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
// //                 <Star className="w-3 h-3 fill-white" /> {rating}
// //               </span>
// //               <div className="text-white">
// //                 <p className="font-bold text-lg leading-tight">APIC {city}</p>
// //                 <p className="flex items-center gap-1 text-sm text-indigo-100">
// //                   <MapPin className="w-3.5 h-3.5" /> {city}
// //                 </p>
// //               </div>
// //             </div>

// //             <div className="p-5">
// //               <div className="grid grid-cols-3 text-center mb-5">
// //                 <div>
// //                   <p className="font-bold text-gray-900">{machines}</p>
// //                   <p className="text-[11px] text-gray-500 tracking-wide">MACHINES</p>
// //                 </div>
// //                 <div>
// //                   <p className="font-bold text-gray-900">{experts}</p>
// //                   <p className="text-[11px] text-gray-500 tracking-wide">EXPERTS</p>
// //                 </div>
// //                 <div>
// //                   <p className="font-bold text-gray-900">{utilised}%</p>
// //                   <p className="text-[11px] text-gray-500 tracking-wide">UTILISED</p>
// //                 </div>
// //               </div>

// //               <Link
// //                 to={`/app/facilities/${city.toLowerCase()}/machines`}
// //                 className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition"
// //               >
// //                 <Settings className="w-4 h-4" />
// //                 View Machines & Book
// //                 <ArrowRight className="w-4 h-4" />
// //               </Link>
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       {filtered.length === 0 && (
// //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl mb-6">
// //           No centres match your search.
// //         </div>
// //       )}

// //       {/* Tip */}
// //       <div className="flex items-start gap-2 text-sm text-gray-500">
// //         <span className="text-xs font-semibold px-2 py-0.5 rounded bg-amber-50 text-amber-700 shrink-0">
// //           Tip
// //         </span>
// //         <span>
// //           Machines are managed by each centre's APIC admin — bookings happen directly on the centre page.
// //         </span>
// //       </div>
// //     </div>
// //   );
// // }


// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Search, Star, MapPin, Settings, ArrowRight, Loader2 } from "lucide-react";
// import facilityService from "../service/facilityService";

// export default function Facilities() {
//   const [query, setQuery] = useState("");
//   const [facilities, setFacilities] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     fetchFacilities();
//   }, []);

//   const fetchFacilities = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const response = await facilityService.getAllFacilities();

//       // Handle different response formats
//       if (Array.isArray(response)) {
//         setFacilities(response);
//       } else if (response.data && Array.isArray(response.data)) {
//         setFacilities(response.data);
//       } else if (response.success && response.data && Array.isArray(response.data)) {
//         setFacilities(response.data);
//       } else {
//         setFacilities([]);
//         setError(response.message || "No facilities found.");
//       }
//     } catch (err) {
//       console.error("Error fetching facilities:", err);
//       setError(err.message || "Failed to load facilities. Please try again.");
//       setFacilities([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filtered = facilities.filter((c) =>
//     c.facilityName?.toLowerCase().includes(query.toLowerCase()) ||
//     c.city?.toLowerCase().includes(query.toLowerCase()) ||
//     c.state?.toLowerCase().includes(query.toLowerCase())
//   );

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
//         <span className="ml-3 text-gray-600">Loading facilities...</span>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div>
//         <h1 className="text-3xl font-extrabold text-gray-900">APIC Facilities</h1>
//         <p className="text-gray-500 mt-1 mb-6">
//           Explore centres across Andhra Pradesh and book machines from within each centre.
//         </p>
//         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
//           {error}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">APIC Facilities</h1>
//       <p className="text-gray-500 mt-1 mb-6">
//         Explore centres across Andhra Pradesh and book machines from within each centre.
//       </p>

//       {/* Search */}
//       <div className="bg-white border border-gray-200 rounded-2xl p-3 mb-6">
//         <div className="flex items-center gap-2 px-3">
//           <Search className="w-4 h-4 text-gray-400" />
//           <input
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             placeholder="Search centre or city..."
//             className="w-full text-sm focus:outline-none bg-transparent"
//           />
//         </div>
//       </div>

//       {/* Centre cards */}
//       <div>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
//           {filtered.map((facility) => (
//             <div
//               key={facility.id}
//               className="rounded-2xl overflow-hidden border border-gray-100"
//             >
//               <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
//                 <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
//                   <Star className="w-3 h-3 fill-white" /> {facility.rating || 0}
//                 </span>
//                 <div className="text-white">
//                   <p className="font-bold text-lg leading-tight">{facility.facilityName}</p>
//                   <p className="flex items-center gap-1 text-sm text-indigo-100">
//                     <MapPin className="w-3.5 h-3.5" /> {facility.city}, {facility.state}
//                   </p>
//                 </div>
//               </div>

//               <div className="p-5">
//                 <div className="grid grid-cols-3 text-center mb-5">
//                   <div>
//                     <p className="font-bold text-gray-900">0</p>
//                     <p className="text-[11px] text-gray-500 tracking-wide">MACHINES</p>
//                   </div>
//                   <div>
//                     <p className="font-bold text-gray-900">{facility.totalExperts || 0}</p>
//                     <p className="text-[11px] text-gray-500 tracking-wide">EXPERTS</p>
//                   </div>
//                   <div>
//                     <p className="font-bold text-gray-900">{facility.utilizationPercentage || 0}%</p>
//                     <p className="text-[11px] text-gray-500 tracking-wide">UTILISED</p>
//                   </div>
//                 </div>

//                 <Link
//                   to={`/app/facilities/${facility.id}/machines`}
//                   state={{ facilityName: facility.facilityName, facility }}
//                   className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition"
//                 >
//                   <Settings className="w-4 h-4" />
//                   View Machines & Book
//                   <ArrowRight className="w-4 h-4" />
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {filtered.length === 0 && (
//         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl mb-6">
//           No centres match your search.
//         </div>
//       )}

//       {/* Tip */}
//       <div className="flex items-start gap-2 text-sm text-gray-500">
//         <span className="text-xs font-semibold px-2 py-0.5 rounded bg-amber-50 text-amber-700 shrink-0">
//           Tip
//         </span>
//         <span>
//           Machines are managed by each centre's APIC admin — bookings happen directly on the centre page.
//         </span>
//       </div>
//     </div>
//   );
// }